import React, { ReactElement, useContext, useState, PropsWithChildren } from 'react';

export enum ViewType
{
    Dashboard = 0,
    Map,
    Grid
}

/**
 * Creates the contexts.
 */
const ViewTypeContext = React.createContext<ViewType>(ViewType.Dashboard);
const ViewTypeUpdateContext = React.createContext<(value: ViewType) => void>(() => {});

/**
 * Creates the contexts hooks
 */
export const useViewType = () => useContext(ViewTypeContext);
export const useViewTypeUpdate = () => useContext(ViewTypeUpdateContext);

/**
 * Gets the dependency provider component.
 * @param props The component properties.
 */
export function ViewTypeContextProvider(props: PropsWithChildren<{}>): ReactElement
{
    const [viewType, setViewType] = useState<ViewType>(ViewType.Dashboard);

    return (
        <ViewTypeContext.Provider value={viewType}>
            <ViewTypeUpdateContext.Provider value={setViewType}>
                {props.children}
            </ViewTypeUpdateContext.Provider>
        </ViewTypeContext.Provider>
    );
}